import * as React from "react";
import { classes, style } from "typestyle";
import SidebarItem from "./SidebarItem";
import { Black } from "@traceair/tds";

export interface IProps {
  leftIcon?: React.ReactNode;
  leftLabel?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onRightIconClick?: () => void;
}

const SidebarHeader = ({
  leftIcon,
  leftLabel,
  rightIcon,
  onRightIconClick,
}: IProps) => (
  <div
    className={classes(
      "sidebar-header",
      style({ boxShadow: "0px 3px 4px -2px rgba(0, 0, 0, 0.3)" }),
    )}
  >
    <SidebarItem
      backgroundColor={Black}
      leftIcon={leftIcon || null}
      leftLabel={leftLabel || null}
      rightIcon={rightIcon || null}
      onRightIconClick={onRightIconClick || null}
      height="40px"
    />
  </div>
);

export default SidebarHeader;
